<template>
    <div class="ConnectedMembers">
        <el-card class="box-card">
            <el-collapse v-model="connected_members_collapse" accordion>
                <el-collapse-item name="1">
                    <template slot="title">
                        <div class="flex">
                            <img src="../assets/images/myAccount/conected_members.png" style="width: 18px;">
                            <div class="label-md-bold-black left-margin-10">Connected Members ({{ connected_members_list.length }})</div>
                        </div>
                    </template>
                    <div>
                        <el-table
                            :data="connected_members_list"
                            max-height="450"
                            style="width: 100%"
                        >
                            <el-table-column width="50">
                                <template slot-scope="scope">
                                    <Hexagon :rank="scope.$index +1"></Hexagon>
                                </template>
                            </el-table-column>

                            <el-table-column width="50">
                                <template>
                                    <img src="../assets/images/navBar/avatar.jpg" class="profile-pic">
                                </template>
                            </el-table-column>

                            <el-table-column prop="member_name"></el-table-column>

                            <el-table-column>
                                <template slot-scope="scope">
                                    <span class="sub-text">{{ connected_members_list[scope.$index].email }}</span>
                                </template>
                            </el-table-column>

                            <el-table-column align="right">
                                <template>
                                    <el-button size="mini" class="table-action-btn">REMOVE</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                </el-collapse-item>
            </el-collapse>
        </el-card>
    </div>
</template>

<script>
import { serverAddr, serverAddrToUploadMediaFiles, serverHostName } from "../networkConfig";
import { EventBus } from "../eventBus";
import Hexagon from "@/components/Hexagon.vue";

export default {
    name: 'ConnectedMembers',
    components: {
        Hexagon
    },
    data() {
        return {
            search_history: '',
            payment_category: 'all_categories',
            connected_members_collapse: 1,
            connected_members_list: [
                {
                    member_name: 'Rajesh Verma',
                    email: 'rajesverma@gmail.com',
                },
                {
                    member_name: 'Sonali Thakkar',
                    email: 'sonalithakkar@gmail.com'
                },
                {
                    member_name: 'Harmesh Mehta',
                    email: 'harmeshmehta@gmail.com'
                },
                {
                    member_name: 'Mayur Fegde',
                    email: 'mayurfegde@gmail.com'
                },
                {
                    member_name: 'Nilesh Soman',
                    email: 'nileshsoman@gmail.com'
                }
            ]
        }
    },
}
</script>
<style lang="scss" scoped>
@import "../css/variable.scss";
@import "../css/common.scss";
.ConnectedMembers .profile-pic{
    height: 30px;
    width: 30px;
    object-fit: cover;
    border-radius: 100%;
}
</style>
<style lang="scss">
@import "../css/variable.scss";
@import "../css/common.scss";
.ConnectedMembers .el-table__row .cell{
    color: #000;
    font-size: 13px;
    font-weight: 500;

    .sub-text{
        font-size: 12px;
        color: #999;
    }

    .table-action-btn{
        border-radius: 50px;
        color: #a5a6a8;
        border-color: #a5a6a8;
    }
    .table-action-btn:hover{
        color: $primary-theme-color;
        border-color: $primary-theme-color;
        background: #fff;
    }
}
.ConnectedMembers .el-table__fixed{
    z-index: 1;
}
</style>
